module.exports = __webpack_public_path__ + "media/st_nicolaes_church.a90cf001.wav";